import { REQUEST_ERROR, REQUEST_SUCCESS } from '@/core/events'

const CRUDMixinFactory = (repository, EventBus: null | any = null) => {
  const onSuccess = () => {
    EventBus && EventBus.$emit(REQUEST_SUCCESS)
  }
  const onError = () => {
    EventBus && EventBus.$emit(REQUEST_ERROR)
  }
  return {
    fetch(id: string) {
      return repository.get(id).then(({ data }) => {
        return data
      })
    },
    async save(item: any) {
      return item.id ? this.update(item) : this.create(item)
    },
    create(item: any) {
      return repository
        .create(item)
        .then(({ data }) => {
          onSuccess()
          return data
        })
        .catch(error => {
          onError()
          return Promise.reject(error)
        })
    },
    update(item: any) {
      return repository
        .update(item.id, item)
        .then(({ data }) => {
          onSuccess()
          return data
        })
        .catch(error => {
          onError()
          return Promise.reject(error)
        })
    },
    delete(item: any) {
      return repository
        .delete(item.id)
        .then(({ data }) => {
          onSuccess()
          return data
        })
        .catch(error => {
          onError()
          return Promise.reject(error)
        })
    },
  }
}

export { CRUDMixinFactory }
